import React from 'react';
import { useTranslation } from 'react-i18next';
import { css, RuleSet } from 'styled-components';
import { Button } from '../../../ui/Button';
import { ButtonType } from '../../../../styled/theme/types';

interface KapitalbankButtonProps {
  styles?: RuleSet<object>;
  onClick: () => void;
}

const getButtonStyles = (styles?: RuleSet<object>) => css`
  height: 48px;
  ${styles};
  transition:
    background-color 0.3s,
    border-color 0.3s;

  > span {
    transition: color 0.3s;
  }

  @media (hover: hover) {
    &:hover {
      background-color: ${({ theme }) => theme.colors.background.primary};
      border: 1px solid ${({ theme }) => theme.colors.systemColors.kapital};

      > span {
        color: ${({ theme }) => theme.colors.systemColors.kapital};
      }
    }
  }
`;

export const KapitalbankButton: React.FC<KapitalbankButtonProps> = ({
  styles,
  onClick
}) => {
  const { t } = useTranslation();

  return (
    <Button
      stat="product-kapitalbank-btn"
      onClick={onClick}
      text={t('pages.current_item.buy_in_mortgage')}
      cypress="product-kapitalbank-btn"
      state={ButtonType.kapitalBank}
      styles={getButtonStyles(styles)}
    />
  );
};
